import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/AuthContext";

/** The two type catalogues behind the one menu item "Tipovi delova". */
export type TypeCatalog = "parts" | "articles";

/** List route of each catalogue; the editors hang below them (`/tipovi/:id`, `/tipovi/artikli/:id`). */
export const TYPE_CATALOG_PATHS: Record<TypeCatalog, string> = {
  parts: "/tipovi",
  articles: "/tipovi/artikli",
};

/** Functions that open the screen — the menu item and the `/tipovi` route accept either. */
export const TYPE_CATALOGS_ANY_OF = ["types:view", "article-types:view"];

/**
 * Switch between part types and article types (Strahinja, 2026-10-12: "Tipovi artikala"
 * is a view of "Tipovi delova", not a menu item of its own — same pattern as "Atributi i
 * jedinice"). Each view is a route, so the editors' "Nazad" and the browser land on the
 * right list. Shown only to a user who reads both catalogues; with one of them the screen
 * is simply that list.
 */
export function TypeCatalogSwitch({ value }: { value: TypeCatalog }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  if (!TYPE_CATALOGS_ANY_OF.every((p) => hasPermission(p))) return null;

  const items: { value: TypeCatalog; label: string }[] = [
    { value: "parts", label: t("types.switch.parts", "Tipovi delova") },
    { value: "articles", label: t("types.switch.articles", "Tipovi artikala") },
  ];
  return (
    <div className="seg" role="group" aria-label={t("types.switch.label", "Katalog tipova")}>
      {items.map((it) => (
        <button
          key={it.value}
          type="button"
          className={it.value === value ? "is-on" : undefined}
          aria-pressed={it.value === value}
          onClick={() => { if (it.value !== value) navigate(TYPE_CATALOG_PATHS[it.value], { replace: true }); }}
        >
          {it.label}
        </button>
      ))}
    </div>
  );
}
